import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrowRight",
  "use": "icon-arrowRight-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 22 22\" id=\"icon-arrowRight\"><path fill=\"#F0F0F0\" d=\"M21.342 9.94 10.234.297a.47.47 0 0 0-.309-.114H7.323a.234.234 0 0 0-.153.411l10.297 8.938H.26a.236.236 0 0 0-.235.236v1.764c0 .13.106.235.235.235h17.204L7.167 20.706a.234.234 0 0 0 .153.412h2.69c.056 0 .112-.02.153-.059l11.179-9.697a.943.943 0 0 0 0-1.423\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol